import React from 'react'
import serverMaintenance from './../../../src/servermaintenance.png'; 
import './../../App.css'
const Maintenance = () => {
  return (
    <div>
       <img style={{display:'block',  'margin-left': 'auto', 'margin-right': 'auto', marginTop:'2%'}} src={serverMaintenance} alt="Canvas Logo" />
    
      <label className ='maintenanceMsg1'><span style={{fontWeight:'bold'}}>Oops...</span> Please Register between</label>
      <br/>
      <label className ='maintenanceMsg2'>9 AM to 8 PM</label>
      </div>
  )
}

export default Maintenance
